import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Facebook, Twitter, Instagram, Linkedin } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export default function Team() {
  const { settings } = useSettings();
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/team");
        setTeam(data);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div>
      <div className="border-b-2 border-primary pb-4 mb-8">
        <div className="font-ui text-xs uppercase tracking-[0.3em] text-muted-foreground">Editorial Team</div>
        <h1 className="font-kannada-heading text-4xl sm:text-5xl mt-1">
          ನಮ್ಮ ತಂಡ <span className="text-primary">.</span>
        </h1>
      </div>

      {/* Editor-in-chief from settings */}
      {settings?.editor_name && (
        <section className="border border-border bg-card p-6 rounded-sm mb-10" data-testid="team-editor-chief">
          <div className="flex flex-col sm:flex-row gap-6 items-start">
            {settings.editor_photo_url && (
              <img
                src={settings.editor_photo_url}
                alt={settings.editor_name}
                className="w-32 h-32 object-cover rounded-sm border border-border"
              />
            )}
            <div>
              <div className="font-ui text-[10px] uppercase tracking-[0.3em] text-primary font-bold">
                {settings.editor_designation}
              </div>
              <div className="font-kannada-heading text-3xl mt-1">{settings.editor_name}</div>
              {settings.editor_bio && (
                <p className="font-kannada-body text-base mt-3 leading-relaxed max-w-2xl">
                  {settings.editor_bio}
                </p>
              )}
            </div>
          </div>
        </section>
      )}

      <h2 className="font-kannada-heading text-2xl mb-6">ಉಪ ಸಂಪಾದಕರು ಮತ್ತು ವರದಿಗಾರರು</h2>

      {loading ? (
        <p className="text-muted-foreground">Loading...</p>
      ) : team.length === 0 ? (
        <p className="font-kannada-body text-muted-foreground">
          ತಂಡದ ಸದಸ್ಯರನ್ನು ಇನ್ನೂ ಸೇರಿಸಲಾಗಿಲ್ಲ.
        </p>
      ) : (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="team-grid">
          {team.map((m) => (
            <div key={m.id} className="border border-border bg-card p-5 rounded-sm card-lift" data-testid={`team-card-${m.id}`}>
              <div className="flex items-start gap-4">
                <img
                  src={m.photo_url}
                  alt={m.name}
                  className="w-20 h-20 object-cover rounded-sm border border-border shrink-0"
                />
                <div className="min-w-0">
                  <div className="font-kannada-heading text-lg leading-tight">{m.name}</div>
                  <div className="text-[10px] uppercase tracking-widest text-primary font-bold mt-1">
                    {m.role}
                  </div>
                </div>
              </div>
              {m.bio && (
                <p className="font-kannada-body text-sm mt-3 leading-relaxed text-muted-foreground line-clamp-3">
                  {m.bio}
                </p>
              )}
              <div className="mt-4 flex gap-2">
                {m.twitter && (
                  <a href={m.twitter} target="_blank" rel="noreferrer" className="w-8 h-8 grid place-items-center border border-border hover:bg-foreground hover:text-background rounded-sm transition-colors">
                    <Twitter className="w-3.5 h-3.5" />
                  </a>
                )}
                {m.facebook && (
                  <a href={m.facebook} target="_blank" rel="noreferrer" className="w-8 h-8 grid place-items-center border border-border hover:bg-foreground hover:text-background rounded-sm transition-colors">
                    <Facebook className="w-3.5 h-3.5" />
                  </a>
                )}
                {m.instagram && (
                  <a href={m.instagram} target="_blank" rel="noreferrer" className="w-8 h-8 grid place-items-center border border-border hover:bg-foreground hover:text-background rounded-sm transition-colors">
                    <Instagram className="w-3.5 h-3.5" />
                  </a>
                )}
                {m.linkedin && (
                  <a href={m.linkedin} target="_blank" rel="noreferrer" className="w-8 h-8 grid place-items-center border border-border hover:bg-foreground hover:text-background rounded-sm transition-colors">
                    <Linkedin className="w-3.5 h-3.5" />
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
